import { Modal, ModalContent } from "semantic-ui-react";
import * as React from "react";
import "./video-modal.css";

export default function VideoModal({ thumbnailUrl, videoUrl, caption }: {
    thumbnailUrl: string;
    videoUrl: string;
    caption?: string;
}): JSX.Element {
    const [open, setOpen] = React.useState(false);

    return (
        <div className="videoModal">
            <Modal
                basic={true}
                open={open}
                size="large"
                trigger={
                    <div className="preview">
                        <img className="thumbnail" width="200" height="auto" src={thumbnailUrl} alt="Video"/>
                        {caption !== undefined && <span className="caption">{caption}</span>}
                    </div>
                }
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                className="videoModal"
            >
                <ModalContent>
                    <video controls={true}>
                        <source
                            src={videoUrl}
                            type="video/mp4"/>
                    </video>
                </ModalContent>
            </Modal>
        </div>
    );
}
